import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

import { getAssetMediaKind } from '@/entities/assets';

export type AlbumMediaCounts = {
  photoCount: number;
  videoCount: number;
};

// Assets arrive through the patient stream after the album itself, so an
// unloaded asset is counted as a photo rather than hidden from the total.
export const getAlbumMediaCounts = (
  assetIDs: string[],
  assets: Record<string, Asset | undefined>,
): AlbumMediaCounts => {
  const videoCount = assetIDs.filter(
    (assetID) => getAssetMediaKind(assets[assetID]) === 'video',
  ).length;

  return {
    photoCount: assetIDs.length - videoCount,
    videoCount,
  };
};
